import LiveGameCard from '../../partials/LiveGameCard';

// import styles from '../../../../styles/items/games/default.module.scss';

interface LiveQuizProps {
    canParticipate?: boolean;
    game: Game;
    className?: string;
}

function LiveQuiz({ game = null, className = null, ...props }: LiveQuizProps) {
    return <LiveGameCard className={className} game={game} withChoose {...props} />;
}

export default LiveQuiz;
